import classnames from 'classnames';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import { pickContextTypes } from '../context-types';

import Progress from './progress/progress';
import Play from './play/play';
import Time from './time/time';
import Volume from './volume/volume';
import FullScreen from './fullscreen/fullscreen';

import styles from './controls.styl';


@WixConnect(styles)
export default class Controls extends React.Component {
  static contextTypes = pickContextTypes('paused', 'beenPlayed', 'ended', 'simple', 'mobileMode', 'fullScreen');

  static propTypes = {
    className: React.PropTypes.string,
    children: React.PropTypes.node,
  };

  render() {
    const { className } = this.props;
    const { paused, beenPlayed, ended, simple, mobileMode, fullScreen } = this.context;

    // in simple mode we always show controls
    if (!simple) {
      // in mobile mode we show controls only if video is in fullscreen mode
      if (mobileMode && !fullScreen) {
        return null;
      } else if (!beenPlayed || ended) {
        return null;
      }
    }

    const styleNames = classnames('controls', {
      simple,
      'mobile-mode': mobileMode,
      'at-full-screen': fullScreen,
      paused,
      mobileMode,
    });

    return (
      <section>
        {this.props.children}
        <section styleName={styleNames}
                 className={className}>
          <section styleName="controls-row"
                   className="qa-player-controls-row">
            <Play styleName="play"
                  className="qa-player-play" />
            <Time styleName="time"
                  className="qa-player-time" />
            <Progress styleName="progress"
                      className="qa-player-progress" />
            <Volume styleName="volume"
                    className="qa-player-volume" />
            <FullScreen styleName="fullscreen" />
          </section>
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/controls/controls.js